export const royalMailCost = '5'